






























import { defineComponent, PropType, computed, useContext, ref, onMounted, onUnmounted } from '@nuxtjs/composition-api';
import { throttle } from 'lodash-es';
import ProductCartButton from '~/components/pages/Product/ProductCartButton.vue';
import AppFavoriteTextButton from '~/components/partials/App/AppFavoriteTextButton.vue';
import AppRectButton from '~/components/partials/App/AppRectButton.vue';
import { STOCK_SECTION_ANCHOR_POINT, PRODUCT_CART_BUTTON, CART_BUTTON_SECTION_ANCHOR_POINT } from '~/constants';
import { getLotteryInfoFromEC } from '~/utils/checkLotteryStatus';
import { ProductShowECResponseSchema } from '~/types/modules/product';
import { ProductCategoryId } from '~/enums';

export default defineComponent({
  components: {
    AppRectButton,
    ProductCartButton,
    AppFavoriteTextButton,
  },
  props: {
    ecResponse: {
      type: Object as PropType<ProductShowECResponseSchema>,
      required: true,
    },
    isFavorite: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const { i18n } = useContext();
    const isCartButtonSectionPassed = ref(false);

    const hasStock = computed(
      () => (props.ecResponse.product_variants?.filter((variant) => variant.stock_count) || []).length > 0
    );

    const isNowOnSale = computed(() => props.ecResponse.product_variants.some((variant) => variant.now_on_sale_flag));

    const productCategory = computed(() => props.ecResponse.categories[0]?.id || ProductCategoryId.WINE);
    const hasTwoOrMoreVintage = computed(
      () =>
        props.ecResponse.product_variants.length > 1 &&
        [ProductCategoryId.WINE, ProductCategoryId.OTHER_ALCOHOL, ProductCategoryId.GIFT_SET].includes(
          productCategory.value
        )
    );

    const lottery = computed(() => {
      const lotteryInfo = props.ecResponse.product_variants[0].raffle_item?.raffle;

      return {
        ...getLotteryInfoFromEC(lotteryInfo),
        text: i18n.t('Item-03.button.withinLotteryPeriod.type4').toString(),
      };
    });

    // カートボタン領域を過ぎたらタブバーを表示する
    const updateFooterVisibility = throttle(() => {
      const cartButtonSection = document.getElementById(CART_BUTTON_SECTION_ANCHOR_POINT)?.getBoundingClientRect();
      isCartButtonSectionPassed.value = (cartButtonSection?.bottom || 0) < 0;
    }, 100);
    onMounted(() => {
      window.addEventListener('scroll', updateFooterVisibility);
    });
    onUnmounted(() => {
      window.removeEventListener('scroll', updateFooterVisibility);
    });

    return {
      hasStock,
      isNowOnSale,
      hasTwoOrMoreVintage,
      STOCK_SECTION_ANCHOR_POINT,
      PRODUCT_CART_BUTTON,
      lottery,
      isCartButtonSectionPassed,
    };
  },
});
